import React from 'react';
import { useIntl } from 'react-intl';
import { ErrorBoundary } from './ErrorBoundary';
import { TypedMemo } from '../common/types';

const GlobalErrorBoundaryHandlerComponent: React.FC<React.PropsWithChildren> = ({ children }) => {
  const intl = useIntl();

  return <ErrorBoundary locale={intl.locale}>{children}</ErrorBoundary>;
};

export const GlobalErrorBoundaryHandler = TypedMemo(GlobalErrorBoundaryHandlerComponent);
